import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "profile-info d-sm-flex align-items-center mb-10" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "d-block text-dark-emphasis mb-0 small" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil text-black position-relative top-1 fs-16 me-1" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "info mt-25 ps-0 mb-0 list-unstyled" }
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-success rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-envelope-simple" })
], -1 /* HOISTED */)
const _hoisted_12 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "position-relative" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning-light rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-phone" })
], -1 /* HOISTED */)
const _hoisted_16 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-primary rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-person" })
], -1 /* HOISTED */)
const _hoisted_20 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_21 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_22 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-muted rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-user-circle" })
], -1 /* HOISTED */)
const _hoisted_24 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_25 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_26 = { class: "mt-25 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RecoveryPasswordButton = _resolveComponent("RecoveryPasswordButton")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createCommentVNode(" <h1 class=\"text-black fw-medium mb-8\">{{ user.firstname }} {{ user.lastname }}</h1> "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user.id), 1 /* TEXT */)
            ])
          ]),
          _createCommentVNode(" <div class=\"border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30\"></div> "),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t('form.section.personal_information')), 1 /* TEXT */),
            _createVNode(_component_router_link, {
              to: {
                    path: `/user/${_ctx.user.id}/edit`, query: {
                        center_id: _ctx.center_id
                    }
                },
              class: "d-inline-block text-decoration-none lh-1 text-muted fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.edit')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ]),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
              _createElementVNode("a", {
                href: `mailto:${_ctx.user.email}`,
                class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
              }, _toDisplayString(_ctx.user.email), 9 /* TEXT, PROPS */, _hoisted_13)
            ]),
            _createElementVNode("li", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
              _createElementVNode("a", {
                href: `tel:${_ctx.user.phone_number}`,
                class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
              }, _toDisplayString(_ctx.user.phone_number), 9 /* TEXT, PROPS */, _hoisted_17)
            ]),
            (!_ctx.user.role.is_custom_role)
              ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('form.role.label')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.user.role.name), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.user.role_in_department)
              ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('form.role_in_department.label')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.user.role_in_department), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_RecoveryPasswordButton, {
              user_id: _ctx.user.id
            }, null, 8 /* PROPS */, ["user_id"])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}